import { DSDarkColors, DSLightColors } from '../colors';

import { SEMANTIC_ALIASES } from './aliases.generated';
import type { DSPalette, DSSemantic } from './semantic.types';

type AliasNode = string | { [key: string]: AliasNode };

/** 'gray.800' -> значение из палитры */
const resolve = (palette: DSPalette, path: string): string =>
  path.split('.').reduce<any>((group, key) => group[key], palette);

/**
 * Раскрывает карту ролей на переданной палитре. Светлая и тёмная темы
 * собираются из одной карты, поэтому разойтись с палитрой не могут.
 */
const build = (palette: DSPalette): DSSemantic => {
  const walk = (node: AliasNode): unknown => {
    if (typeof node === 'string') {
      return resolve(palette, node);
    }

    const result: Record<string, unknown> = {};
    Object.keys(node).forEach((key) => {
      result[key] = walk(node[key]);
    });

    return result;
  };

  return walk(SEMANTIC_ALIASES) as DSSemantic;
};

export const DSLightSemantic = build(DSLightColors);
export const DSDarkSemantic = build(DSDarkColors);
